module.exports = __webpack_public_path__ + "static/howtosavetime-5b1348fc4bd2f98440fa71aeae589826.gif";